import { render, staticRenderFns } from "./TeamVisit.vue?vue&type=template&id=65d4b636&scoped=true&"
import script from "./TeamVisit.vue?vue&type=script&lang=js&"
export * from "./TeamVisit.vue?vue&type=script&lang=js&"
import style0 from "./TeamVisit.vue?vue&type=style&index=0&id=65d4b636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4b636",
  null
  
)

export default component.exports